var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Stats"}},[_c('h4',[_vm._v("Statistics about this content item will appear here...")])])}
var staticRenderFns = []

export { render, staticRenderFns }